import { render, staticRenderFns } from "./VesselRecordDieselGeneratorPieChart.vue?vue&type=template&id=33270d6a&scoped=true&"
import script from "./VesselRecordDieselGeneratorPieChart.vue?vue&type=script&lang=js&"
export * from "./VesselRecordDieselGeneratorPieChart.vue?vue&type=script&lang=js&"
import style0 from "./VesselRecordDieselGeneratorPieChart.vue?vue&type=style&index=0&id=33270d6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33270d6a",
  null
  
)

export default component.exports